var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_c('span',{staticClass:"code"},[_vm._v(_vm._s(_vm.code))]),_vm._v(_vm._s(_vm.msg))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" Please move to "),_c('a',{attrs:{"href":"http://crm2b.org"}},[_vm._v("CRM2B ORG production")]),_vm._v(". ")])
}]

export { render, staticRenderFns }